module.exports = __webpack_public_path__ + "static/p01_back-be5c5dc110586ea6aae8b2681647bdb3.jpg";